import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";
import { Link } from "react-router-dom";

// Fix default marker icons (we use divIcon instead)
const pinIcon = (status = "available") => {
  const colors = { available: "#7C3AED", claimed: "#E5B15D", gone: "#A8A6A1" };
  return L.divIcon({
    className: "",
    html: `<div style="
      background:${colors[status] || "#7C3AED"};
      width:24px;height:24px;border-radius:50% 50% 50% 0;
      transform:rotate(-45deg);border:2px solid white;
      box-shadow:0 3px 8px rgba(0,0,0,0.25);"></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
  });
};

function FlyTo({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.flyTo(center, zoom || map.getZoom(), { duration: 0.6 });
  }, [center, zoom, map]);
  return null;
}

function ClickPicker({ onPick }) {
  useMapEvents({
    click(e) { onPick && onPick([e.latlng.lat, e.latlng.lng]); },
  });
  return null;
}

export default function MapView({ items = [], center = [40.7128, -74.006], zoom = 12,
                                  pickable = false, marker = null, onPick = null,
                                  className = "" }) {
  return (
    <div className={`relative rounded-2xl overflow-hidden border border-[#E8E5F0] ${className}`}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={true} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FlyTo center={center} zoom={zoom} />
        {pickable && <ClickPicker onPick={onPick} />}
        {pickable && marker && (
          <Marker position={marker} icon={pinIcon("available")} />
        )}
        {items.map((it) => (
          <Marker key={it.id} position={[it.lat, it.lng]} icon={pinIcon(it.status)}>
            <Popup>
              <div className="font-display font-medium text-sm">{it.title}</div>
              <div className="text-xs text-[#6B7280]">{it.category}</div>
              <Link to={`/items/${it.id}`} className="text-xs text-[#7C3AED] underline">View item →</Link>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
